/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeJobsListJobInstances } from "../../funcs/computeJobsListJobInstances.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListJobInstancesRequest$inboundSchema,
};

export const tool$computeJobsListJobInstances: ToolDefinition<typeof args> = {
  name: "compute-jobs-list-job-instances",
  description: `List observed job instances`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeJobsListJobInstances(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
